import React from 'react';
import {Avatar} from '@lightricks/react-design-system';
import useAvatarImageOrInitials from '@/hooks/use-avatar-image-or-initials';
import styles from './MessageCreatorsModal.module.scss';
import {MessageCreator} from './types';

const MAX_STACKED_AVATARS = 3;
const AVATAR_SIZE = 48;
const AVATAR_OVERLAP = AVATAR_SIZE / 2;

function CreatorAvatar({creator}: {creator: MessageCreator}) {
  const {imageUrl, initials} = useAvatarImageOrInitials(
    creator.imageUrl,
    creator.displayName
  );
  return (
    <Avatar
      size="lg"
      src={imageUrl}
      type={imageUrl ? 'picture' : 'initials'}
      initials={initials}
    />
  );
}

function StackedAvatars({creators}: {creators: MessageCreator[]}) {
  const visible = creators.slice(0, MAX_STACKED_AVATARS);
  return (
    <div
      className={styles.stackedAvatars}
      style={{width: AVATAR_SIZE + (visible.length - 1) * AVATAR_OVERLAP}}
    >
      {visible.map((creator) => (
        <div key={creator.id} className={styles.stackedAvatar}>
          <CreatorAvatar creator={creator} />
        </div>
      ))}
    </div>
  );
}

export default StackedAvatars;
